<template>
  <div class="policyDetail">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>
    <div style="width: 1200px; margin: 0 auto">
      <div style="width: 100%; height: 33px"></div>
      <div class="policyDetail-title">{{ data.name }}</div>
      <!-- <div class="policyDetail-date">日期：{{data.createDate.substring(0,10)}}</div>  -->
      <div class="policyDetail-date">日期：{{ date }}</div>
      <div
        style="
          width: 1140px;
          height: 1px;
          background: rgba(238, 238, 238, 1);
          margin-top: 20px;
          margin-bottom: 30px;
        "
      ></div>
      <div v-html="data.content" class="policyDetail-content"></div>
    </div>

    <div style="width: 100%; height: 100px"></div>
  </div>
</template>

<script>
import navigation from "@/components/common/navigation";

export default {
  name: "policyDetail",
  components: {
    navigation,
  },
  data() {
    return {
      data: "",
      date: "",
    };
  },
  methods: {},
  created() {
    let policyId = this.$route.query.id;
    // 地区名列表  /v1/cloud/common/policy/details
    this.$axios
      .post("/v1/cloud/common/policy/details", {
        policyId,
      })
      .then(({ data }) => {
        if (data) {
          this.data = data;
          this.date = data.createDate.substring(0, 10);
        }
      })
      .catch((error) => {
        this.$message({
          message: error.response.data.message,
          type: "warning",
        });
      });
  },
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  },
};
</script>

<style scoped lang="less">
.policyDetail {
  width: 100%;
  min-height: 1000px;
  .policyDetail-title {
    // height:71px;
    line-height: 71px;
    font-size: 26px;
    font-family: MicrosoftYaHei;
    font-weight: 600;
    height: auto;
    text-align: center;
    font-weight: bold;
    color: #000000;
    line-height: 44px;
  }
  .policyDetail-date {
    font-family: MicrosoftYaHei;
    font-weight: 400;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    text-align: center;
  }
  .policyDetail-content {
    width: 1136px;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #333333;
    text-align: justify;
  }
}
</style>